import api from "../config/api";

export const getAllContractors = async () => {
  const res = await api.get("/contractor/");
  return res.data;
};

export const getContractorById = async (id) => {
  const res = await api.get(`/contractor/?id=${id}`);
  return res.data;
};

export const saveContractor = async (data) => {
  const res = await api.post("/contractor/", data, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

export const updateContractor = async (data) => {
  const res = await api.put("/contractor/", data, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

export const deleteContractor = async (id) => {
  const res = await api.delete(`/contractor/?id=${id}`);
  return res.data;
};